<template>
	<div>
		<v-layout row wrap
			justify-end
			align-center
			class="header-booking-data">
			<amounts-component
				:subsidiary-id="params.idSubsidiary"
			/>
			<v-flex xs2>
				<v-select
					class="filter-select"
					hide-details
					:items="subsidiaries"
					item-text="name"
					item-value="id"
					single-line
					v-model="params.idSubsidiary"
				></v-select>
			</v-flex>
		</v-layout>
		<v-layout wrap mb-3 justify-space-between
			align-center>
			<v-flex md4>
				<v-layout wrap align-center>
					<v-flex md6>
						<v-select
							class="filter-select mr3"
							hide-details
							placeholder="Top"
							:items="top"
							single-line
							v-model="topValue"
						>
						</v-select>
					</v-flex>
					<v-flex md6>
						<v-select
							class="filter-select mr3"
							hide-details
							placeholder="Reservas"
							:items="bookings"
							single-line
							v-model="booking"
						>
						</v-select>
					</v-flex>
				</v-layout>
			</v-flex>
			<v-flex md2 class="text-xs-right">
				<button-create
					text="Nueva Empresa"
					:href="createHref"
				></button-create>
			</v-flex>
		</v-layout>
		<table-run
			:columns="columns"
			:rows="rows"
			include-options
			include-settings
			include-delete-single
			@on-sortable-event="columnSortableEvent"
			@on-search-event="searchByColumn"
			@on-delete-event="deleteRow"
			@on-delete-selected="deleteRows"
			@on-export-selected="exportRows"
			@go-to-edit-page="goToEdit"
			class="no-selectable-table">
			<template slot="rows" scope="props">
				<td>{{ props.row.rzSocial }}</td>
				<td>{{ props.row.companyName }}</td>
				<td>{{ props.row.email }}</td>
				<td>{{ props.row.bookingsNumber }}</td>
				<td>{{ props.row.totalExpenses | round | currency(props.row.currency) }}</td>
				<td>{{ props.row.accounts | round | currency(props.row.currency) }}</td>
			</template>
		</table-run>
		<div class="text-xs-right mt-3">
			<v-pagination
				:length="totalPages"
				v-model="params.page"
			></v-pagination>
  		</div>
	</div>
</template>

<script>
	import TableRun from 'table-run';
	import { currency, round } from '@/shared/filters';
	import amountsComponent from '@/components/shared/AmountsComponent';
	import ButtonCreate from '@/components/shared/ButtonCreate';

	function created() {
		this.loadSubsidiaries();
	}

	function columnSortableEvent() {}

	function deleteRow() {}

	function deleteRows() {}

	function exportRows() {}

	function goToEdit({ id }) {
		this.$router.push({ name: 'companies-edit', params: { id } });
	}

	function loadData() {}

	async function loadSubsidiaries() {
		const response = await this.$http.get(`${process.env.PMS_URL}/hotel`);
		this.subsidiaries = response.data.data || [];
		this.params.idSubsidiary = response.data.data[0] ? response.data.data[0].id : 0;
		if (this.params.idSubsidiary > 0) {
			this.loadData();
		}
	}

	function searchByColumn() {}

	function data() {
		return {
			bookings: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 'Todas'],
			booking: 0,
			columns: [
				{ id: 1, name: 'Nombre Completo', code: 'rz_social', isSortable: { down: true, up: false } },
				{ id: 2, name: 'Nombre Comercial', code: 'company_name', isSortable: { down: true, up: false } },
				{ id: 3, name: 'Email', code: 'email', isSortable: { down: true, up: false } },
				{ id: 4, name: 'Reservas', code: 'bookings_number', isSortable: { down: true, up: false } },
				{ id: 5, name: 'Gasto Total', code: 'total_expenses', isSortable: { down: true, up: false } },
				{ id: 6, name: 'Cuentas por Cobrar', code: 'accounts', isSortable: { down: true, up: false } },
			],
			createHref: { name: 'companies-new' },
			params: {
				idSubsidiary: 0,
				page: 1,
			},
			rows: [
				{
					id: 1,
					accounts: 0,
					bookingsNumber: 2,
					companyName: 'Movistar',
					email: 'MovistarSAC@e-gds.com',
					rzSocial: 'Movistar SAC',
					totalExpenses: 1000,
				},
				{
					id: 2,
					accounts: 200,
					bookingsNumber: 3,
					companyName: 'Zhiontag',
					email: 'Zhiontag@yahoo.es',
					rzSocial: 'Zhiontag AS',
					totalExpenses: 2500,
				},
			],
			subsidiaries: [],
			top: [10, 20, 30, 'Todas'],
			topValue: 0,
			totalPages: 1,
		};
	}

	export default {
		name: 'companies-list',
		components: {
			amountsComponent,
			ButtonCreate,
			TableRun,
		},
		created,
		data,
		filters: {
			currency,
			round,
		},
		methods: {
			columnSortableEvent,
			deleteRow,
			deleteRows,
			exportRows,
			goToEdit,
			loadData,
			loadSubsidiaries,
			searchByColumn,
		},
	};
</script>

<style lang="scss" scoped>
	.header-booking-data {
		height: 31px;
		position: absolute;
		right: 20px;
		text-align: right;
		top: 55px;
		width: calc(100% - 230px);

		div {
			padding-bottom: 0px !important;
			padding-top: 0px !important;
		}

		p {
			color: map-get($colors, blue-title);
			font-family: map-get($fonts, regular);
			font-size: 10px;
			margin: 0px;
			text-transform: uppercase;
		}

		span {
			color: map-get($colors, default-skyblue);
			font-family: map-get($fonts, medium);
			font-size: 15px;
		}

		.border-select {
			border-right: 1px solid map-get($colors, border-radio);
			margin-right: 16px;
			padding-right: 16px !important;
		}
	}
</style>



// WEBPACK FOOTER //
// companies-list.vue?2258c819